import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36becae6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sections-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_element = _resolveComponent("search-element");
  const _component_actions_section = _resolveComponent("actions-section");
  const _component_FlexColumn = _resolveComponent("FlexColumn");
  return _openBlock(), _createBlock(_component_FlexColumn, {
    classes: "wrap-with-dropdown-body",
    styles: _ctx.$attrs.style
  }, {
    default: _withCtx(() => [$props.showSearcher ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_ctx.$slots.searcher ? _renderSlot(_ctx.$slots, "searcher", {
      key: 0
    }, undefined, true) : (_openBlock(), _createBlock(_component_search_element, {
      key: 1,
      ref: "searcher",
      placeholder: $props.searchPlaceholder,
      debounce: $props.debounce,
      onSearch: _cache[0] || (_cache[0] = val => _ctx.$emit('search', val)),
      onCleared: _cache[1] || (_cache[1] = $event => _ctx.$emit('restoreSearch'))
    }, null, 8, ["placeholder", "debounce"]))], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "selected", {}, undefined, true), _renderSlot(_ctx.$slots, "list", {}, undefined, true), _ctx.$slots.actions ? _renderSlot(_ctx.$slots, "actions", {
      key: 0
    }, undefined, true) : (_openBlock(), _createBlock(_component_actions_section, {
      key: 1,
      isModified: $props.isModified,
      changes: $props.actionsText,
      name: $props.name,
      onDiscard: _cache[2] || (_cache[2] = $event => _ctx.$emit('discard')),
      onApply: _cache[3] || (_cache[3] = $event => _ctx.$emit('apply')),
      onCloseDropdown: _cache[4] || (_cache[4] = $event => _ctx.$emit('closeDropdown'))
    }, null, 8, ["isModified", "changes", "name"]))])]),
    _: 3
  }, 8, ["styles"]);
}